import React, { useState } from "react";
import Invoke from "../../common/utils/invoke";
import FormRadio from "../../common/components/FormRadio";
import FormInput from "../../common/components/FormInput";
import { validatePolicyorClaimNumber } from "../../common/utils/validation";
import "./TrackClaim.scss";
import BrandLoader from "../../common/components/BrandLoader";

const InlineMessage = ({ isOpen, message }) => {
  if (!isOpen || !message) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "20px",
      }}
    >
      <div
        style={{
          background: "#f5f5f5",
          padding: "12px 16px",
          borderRadius: "8px",
          minWidth: "300px",
          maxWidth: "500px",
          width: "fit-content",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", 
          gap: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        {/* Message LEFT */}
        <span style={{ flex: 1 }}>{message}</span>

      </div>
    </div>
  );
};

const TrackClaimForm = () => {
  const [formData, setFormData] = useState({
    claimType: "",
    policyNo: "",
    claimRefNo: "",
  });



  const [modalOpen, setModalOpen] = useState(false);
  const [responseText, setResponseText] = useState("");
  const [loading, setLoading] = useState(false);

  const [touched, setTouched] = useState({
    claimType: false,
    policyNo: false,
    claimRefNo: false,
  });

  // ---------------- VALIDATION ----------------
  const policyError = touched.policyNo
    ? validatePolicyorClaimNumber(formData.policyNo, "policy number")
    : "";

  const claimRefError = touched.claimRefNo
    ? validatePolicyorClaimNumber(formData.claimRefNo, "claim reference number")
    : "";
const isGroup =
  formData.claimType?.trim().toLowerCase() === "death claim group";

const isFormValid =
  !!formData.claimType &&
  !!formData.claimRefNo &&
  !claimRefError &&
  (isGroup || (!!formData.policyNo && !policyError));

  // ---------------- HANDLE CHANGE ----------------
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "claimType") {
      setFormData({
        claimType: value,
        policyNo: "",
        claimRefNo: "",
      });

      setTouched({
        claimType: true,
        policyNo: false,
        claimRefNo: false,
      });
      setResponseText("");
      setModalOpen(false);
      return;
    }

    setTouched((prev) => ({ ...prev, [name]: true }));

    if (name === "policyNo") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 8) return;
    }

    if (name === "claimRefNo") {
      if (!/^[a-zA-Z0-9]*$/.test(value)) return;
      if (value.length > 14) return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  // ---------------- HANDLE SUBMIT ----------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    setResponseText("");
    setLoading(true);

    try {
      let response;

      if (formData.claimType === "Death Claim Group") {
        response = await Invoke.trackClaimFirst({
          claimNo: formData.claimRefNo,
        });
      } else {
        response = await Invoke.trackClaimSecond({
          claimNo: formData.claimRefNo,
          policyNo: formData.policyNo,
        });
      }

      handleApiResponse(response);
    } catch (err) {
      setResponseText(err?.response?.data?.error || "Something went wrong");
      setModalOpen(true);
    }
    finally {
    setLoading(false);
  }
  };

  // ---------------- RESPONSE HANDLING ----------------
  const handleApiResponse = (response) => {

    if (!response) {
      setResponseText("No response from server.");
      setModalOpen(true);
      return;
    }

    const message =
      response?.operationResponse ||
      response?.errorMessage ||
      "Unexpected response from server.";

    setModalOpen(false);
setResponseText(message); 
setModalOpen(true);

};


  // ---------------- UI ----------------
  return (
    <div className="track-claim-wrapper">
       {/* LOADER */}
    {loading && (
  <div className="loader-overlay">
    <BrandLoader
    color="#8B1E1E"
     />
  </div>
)}
      <div className="track-grievance">
        <h1 className="large-body semibold h6">Track your Claim</h1>

        <div className="track-grievance__card">
          <form className="form-wrapper" onSubmit={handleSubmit}>
            <FormRadio
              name="claimType"
              value={formData.claimType}
              onChange={handleChange}
              label="Claim Type"
              options={["Death Claim Individual", "Death Claim Group"]}
            />

            <div className="form-wrapper">
              {formData.claimType !== "Death Claim Group" && (
                <FormInput
                  name="policyNo"
                  value={formData.policyNo}
                  onChange={handleChange}
                  placeholder="Policy No"
                  error={policyError}
                  label="Policy No"
                />
              )}

              <FormInput
                name="claimRefNo"
                value={formData.claimRefNo}
                onChange={handleChange}
                placeholder="Claim Ref No"
                error={claimRefError}
                label="Claim Reference No"
              />
            </div>

            <div className="form-actions">
              <button
                type="submit"
                disabled={!isFormValid}
                className="track-button btn primary-button regular"
              >
                Submit
              </button>
            </div>
          </form>
<InlineMessage
  isOpen={modalOpen}
  message={responseText}
/>

        </div>
      </div>
    </div>
  );
};

export default TrackClaimForm;
